<template>
    <el-container>
            <el-main>
                <router-view ></router-view>
            </el-main>
    </el-container>
</template>

<script>
    // @ is an alias to c
    import MyNav from '../components/MyNav'
    import Footer from '../components/Footer'
    export default {
        name: 'Home',
        components: {
            MyNav,
            Footer
        },
        methods:{
        }
    }




</script>
<style lang='less' scoped>
    .el-main {
        color: #333;  //333s
        padding:0;
        height: 100vh;
        width: 93.9vm;
    }
    #mainContent{
        width: 600px;
    }
    .charts{
        width: 600px;
    }
    .el-footer {
        background-color: #333333;
        color: #ffffff;
        /*text-align: center;*/
        line-height: 2.7rem;
        padding: 1rem 0;
    }
</style>
